<template>
    <b-container class="order-history">
        <b-row>

            <b-col lg="10" offset-lg="1">
                <h1>Order History</h1>

                <b-card v-for="order in $store.getters['order/items']" :key="order.uuid">
                    <template v-slot:header>
                        <div class="navbar">
                            <div class="mr-5">
                                <strong>Order Placed</strong> <br />
                                {{timestamp(order.created_at)}}
                            </div>
                            <div class="mr-5">
                                <strong>Order Total</strong> <br />
                                ${{formatCurrency(order.total_amount)}}
                            </div>
                            <div class="mr-auto">
                                <strong>Coupon</strong> <br />
                                {{getCoupon(order)}}
                            </div>
                            <div class="ml-auto text-right">
                                <strong>Order Number</strong> <br />
                                {{order.id}}
                            </div>
                        </div>
                    </template>

                    <div class="text-right">
                        <router-link :to="{name: 'order', params: {id: order.uuid}}">Order Details</router-link>
                    </div>

                    <b-table :items="order.projects" :fields="fields" borderless fixed responsive>
                        <template v-slot:cell(talent)="data">
                            {{(data.item.talent) ? data.item.talent.persona : ""}}
                        </template>
                        <template v-slot:cell(prompts)="data">
                            {{(data.item.prompts) ? data.item.prompts.length : 0}}
                        </template>
                        <template v-slot:cell(record_fee)="data">
                            ${{formatCurrency(data.item.record_fee)}}
                        </template>
                        <template v-slot:cell(extra_words_fee)="data">
                            ${{formatCurrency(data.item.extra_words_fee)}}
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button size="sm" variant="primary" :to="{name: 'review', params: {id: data.item.uuid}}"><font-awesome-icon icon="clipboard-list" /> View</b-button>
                            <b-button size="sm" variant="primary" @click="duplicateProject(data.item.uuid)"><font-awesome-icon icon="copy" /> Duplicate</b-button>
                        </template>
                    </b-table>
                </b-card>
            </b-col>

        </b-row>
    </b-container>
</template>
<script>
    import moment from 'moment-timezone'
    export default {
        data() {
            return {
                projects: [],
                fields: [
                    {key: 'name'},
                    {key: 'talent', thStyle: 'width: 135px;'},
                    {key: 'prompts', thStyle: 'width: 85px;'},
                    {key: 'word_count', label: 'Words', thStyle: 'width: 75px;'},
                    {key: 'record_fee', label: 'Session Fee', thStyle: 'width: 115px;'},
                    {key: 'extra_words_fee', label: 'Overage Fee', thStyle: 'width: 115px;'},
                    {key: 'actions', label: '', thStyle: 'width: 170px;', tdClass: 'text-right'}
                ],
                items: [],
            };
        },
        methods: {
            async duplicateProject (uuid) {
                try {
                    const res = await this.$store.dispatch('project/duplicate', uuid)
                    this.$store.commit('project/removeCurrent')
                    this.$store.commit('prompt/clear')

                    this.$router.push({name: 'project_id', params: {id: res.data.uuid}})
                } catch (ex) {
                    console.log(ex.response)
                }
            },
            goToProject: function(project) {
                if(project.status == 'draft') {
                    this.$router.push({name: 'project_id', params: { id: project.id }});
                    return;
                }

                this.$router.push({name: 'review', params: { id: project.id }});
            },            
            getCoupon (order) {
                return (order.coupon) ? order.coupon.coupon_code : 'N/A'
            },
            project (order) {
                if (order.projects[0]) {
                    return order.projects[0]
                }

                return {
                    word_count: 0,
                    prompts: [],
                    record_fee: 0,
                    extra_words_fee: 0,
                    coupon: 'N/A',
                    talent: {
                        name: null
                    }
                }
            },
            timestamp (timestamp) {
                return moment.utc(timestamp, 'YYYY-MM-DD HH:mm:ss').local().format('MM/DD/YYYY')
            },
            formatCurrency (money) {
                return parseFloat(money).toFixed(2)
            }
        },
        computed: {
            
        },
        created() {
            this.$store.dispatch('order/fetch')
                .then(orders => {
                    
                })
        },
        mounted() {
            
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/views/orders/History.vue